// extracted by mini-css-extract-plugin
export var backgroundParallaxLayer = "BackgroundParallax-module--backgroundParallaxLayer--3Jo0w";
export var backgroundParallaxLayerBase = "BackgroundParallax-module--backgroundParallaxLayerBase--286pr";
export var backgroundParallaxLayerBack = "BackgroundParallax-module--backgroundParallaxLayerBack--Kyata";
export var backgroundParallaxLayerDeep = "BackgroundParallax-module--backgroundParallaxLayerDeep--1HUgJ";
export var background = "BackgroundParallax-module--background--3olFJ";